import React, { useState } from 'react';
import classNames from 'classnames';

import { TextType, Text } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { filterButtons, ALL } from './card-data';
import style from './engagement-card.module.less';

export const FilterButtons = ({ setFilteredCards, activeCards }) => {
  const [selectedFilter, setSelectedFilter] = useState(ALL);
  const filterByTag = (tag) => {
    setSelectedFilter(tag);
    if (tag === ALL) {
      setFilteredCards(activeCards);
      return;
    }
    const filteredCards = activeCards.filter((card) => card.tag === tag);
    setFilteredCards(filteredCards);
  };
  return filterButtons.map((filter) => {
    const isSelectedFilter = selectedFilter === filter.tag;
    return (
      <Button
        key={filter.tag}
        className={classNames(style['filter-pill'], {
          [style['selected-filter']]: isSelectedFilter,
        })}
        onClick={() => filterByTag(filter.tag)}
        theme='unstyled'
      >
        <Text className={style['pill-text']} textType={TextType.H4} value={filter.tagText} />
      </Button>
    );
  });
};
